import 'css-chunk:../../frontend/phi3d/src/js/components/FormSelect.module.scss';export default {
  "has_slot": "_has_slot_1gstv_1",
  "no_slot": "_no_slot_1gstv_10",
  "option": "_option_1gstv_29",
  "item": "_item_1gstv_35",
  "radio": "_radio_1gstv_48",
  "selected": "_selected_1gstv_96",
  "disabled": "_disabled_1gstv_104"
};